module.exports = __webpack_public_path__ + "img/06_sc.28ae822e.png";